import React, { useMemo } from 'react';
// material
import { CssBaseline } from '@mui/material';

import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles';

import useSettings from 'src/hooks/useSettings';
import { useTranslation } from 'react-i18next';
import shape from './shape';
import palette from './palette';
import typography from './typography';
import breakpoints from './breakpoints';
import shadows, { customShadows } from './shadows';
import componentsOverride from './overrides';
import { BASE_SPACING } from './layoutConstants';
import { SUPPORTED_TRANSLATIONS } from './themeLanguage';

// ----------------------------------------------------------------------

export default function ThemeConfig({ children }) {
  const { themeMode, themeDirection } = useSettings();
  const { i18n } = useTranslation();
  const isLight = themeMode === 'light';
  const currentLanguageCode = i18n.language.slice(0, 2);
  // const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

  const themeOptions = useMemo(
    () => ({
      palette: isLight
        ? { ...palette.light, mode: 'light' }
        : { ...palette.dark, mode: 'dark' },
      shape,
      typography,
      breakpoints,
      direction: themeDirection,
      shadows: isLight ? shadows.light : shadows.dark,
      customShadows: isLight ? customShadows.light : customShadows.dark,
      spacing: BASE_SPACING,
    }),
    [isLight, themeDirection]
  );

  const theme = createTheme(
    themeOptions,
    ...(SUPPORTED_TRANSLATIONS[currentLanguageCode] ??
      SUPPORTED_TRANSLATIONS.default)
  );
  theme.components = componentsOverride(theme);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
